/* @flow */

import {connect} from 'react-redux';
import TypeFieldComponent from './typeImpl';
import { CONFIRMING_ROLE_ACCOUNTANT, CONFIRMING_ROLE_COMMERCIAL, CONFIRMING_ROLE_OPERATIONS } from 'constants/constants';

const mapStateToProps = (state, props) => ({
  ...props,
  isLoading: state.locale.genericDataIsLoading,
  values: props.isAdministrator || props.hasProcurationUsers || props.hasProcurationGeneralConditions ? state.locale.rolesForConfirming :
          props.hasProcuration ? state.locale.rolesForConfirming.filter(r => r.id === CONFIRMING_ROLE_COMMERCIAL || r.id === CONFIRMING_ROLE_ACCOUNTANT || r.id === CONFIRMING_ROLE_OPERATIONS) :
          state.locale.rolesForConfirming.filter(r => r.id === CONFIRMING_ROLE_COMMERCIAL || r.id === CONFIRMING_ROLE_ACCOUNTANT)
});

export default connect(mapStateToProps)(TypeFieldComponent);
